import * as React from 'react';
import styled from 'styled-components';
import MuiFormControl, { FormControlProps as MuiFormControlProps } from '@material-ui/core/FormControl';

const StyledFormControl: typeof MuiFormControl = styled(MuiFormControl)``;

export type DSFormControlProps = MuiFormControlProps;
export const DSFormControl: React.FC<DSFormControlProps> = props => <StyledFormControl {...props} />;
DSFormControl.displayName = 'DSFormControl';
